import { globby } from 'globby';
import { ERROR_LOG_FILENAME } from '@wix/create-app-definitions';

export async function validateDirectory(projectRoot: string): Promise<boolean> {
  const files = await globby(['*'], {
    ignore: [ERROR_LOG_FILENAME],
    cwd: projectRoot,
  });

  return files.length === 0;
}
